import Vimeo from '@u-wave/react-vimeo';

import type { FunctionComponent } from 'react';
import type { TypeVimeoVideoProps } from './types';

/**
 * VimeoVideo
 */
export const VimeoVideo: FunctionComponent<TypeVimeoVideoProps> = ({
  className = '',
  videoId,
  ...props
}: TypeVimeoVideoProps) => (
  <Vimeo
    {...props}
    video={videoId}
    className={`relative h-0 w-full pb-[56.25%] [&_iframe]:absolute [&_iframe]:left-0 [&_iframe]:top-0 [&_iframe]:h-full [&_iframe]:w-full ${className}`}
    responsive
  />
);

VimeoVideo.displayName = 'VimeoVideo';
